const regexp = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/g
export const stripBaseUrl = (input) => {
  return input.replace(regexp, '')
}

export const removeTrailingSlash = (input) => {
  return input.replace(/\/$/, '')
}

export const getMediaUrl = (input) => {
  if (!input) return ''
  return (
    removeTrailingSlash(process.env.URL_MEDIA_REWRITE) + stripBaseUrl(input)
  )
}
